// @flow
import * as React from 'react';
import styled from 'styled-components';
import { Button } from 'grommet';


const GreyButton = styled(Button)`
    ${(props) => `
        border-color: ${props.borderColor || props.theme.global.colors.buttonBorder};
        border-width: 1px;
        min-height: 32px;
        height: auto;
        overflow: auto;
        &:hover {
            box-shadow: none;
            ${!props.disabled
        && `background-color: ${props.borderColor || props.theme.global.colors.buttonBorder}`}
        }
    `}
`;

export default GreyButton;
